export default __webpack_public_path__ + "static/media/groundnut.f14407ff.png";